// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ab3d80ae","667":"ab9785af","977":"0e1bc391"}[chunkId] + ".chunk.js";
};